<template>
    <span v-if="mostrarBtnCertidoes">
        <b-button variant="primary" @click.stop="obterCertidoes()">
            <span> <i class="fa fa-file-text-o"></i> Certidões</span>
        </b-button>
        <b-modal v-model="mostrarModal" :cancel-disabled="true">
            <div slot="modal-title">Certidões</div>
            <b-row>
                <b-col sm="12">
                    <cnd :fornecedor="fornecedor"></cnd>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <fgts :fornecedor="fornecedor"></fgts>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="primary" @click.stop="fecharModal()"
                    >Ok</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import Cnd from './../../fornecedor/certidoes/Cnd'
import Fgts from './../../fornecedor/certidoes/Fgts'

export default {
    components: {
        Cnd,
        Fgts
    },

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            fornecedor: {}
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterCertidoes() {
            this.$store.dispatch('addRequest')
            this.servicos
                .obterCertidoes(this.pagamento.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.fornecedor = response.data
                            this.mostrarModal = true
                        } else {
                            this.$toast.error(
                                (response.errors && response.errors[0]) || 'Erro ao obter certidões',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnCertidoes() {
            return this.$temAcesso('GESCON-UFI-PAG-03')
        }
    }
}
</script>
